import { Color } from "@starrez/starryui";
import styled from "styled-components";
import { IEditButtonStyleProps } from ".";

export const Button = styled.button<IEditButtonStyleProps>`
    font-family: Roboto, Arial, Helvetica, sans-serif;
    border: none;
    cursor: pointer;
    display:flex;
    padding: 7px 12px;
    border-radius: 3px;
    font-weight: 700;
    font-size: 14px !important;

    color: ${Color.Blue.B60};
    background-color: ${Color.Grey.G30};

    ${(props) => props.IsHovering && `
        background-color: ${Color.Blue.B60};
        color: #fff;
    `}
`;
